async function exportTemplate(constructorId, httpClient) {
  const { data } = await httpClient({
    url: `/calendar/template?constructorId=${constructorId}`,
    method: 'GET',
  })
  const byteArray = Uint8Array.from(atob(data.data), (c) => c.charCodeAt(0))
  const blob = new Blob([byteArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'calendrier-inspections.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

async function validateImport(rows, constructorId, httpClient) {
  const { data } = await httpClient({
    url: '/calendar/import/validate',
    method: 'POST',
    data: JSON.stringify({ rows, constructorId: constructorId || null }),
  })
  return data
}

async function confirmImport(rows, httpClient) {
  const { data } = await httpClient({
    url: '/calendar/import/confirm',
    method: 'POST',
    data: JSON.stringify({ rows }),
  })
  return data
}

export default { exportTemplate, validateImport, confirmImport }
